<template>
  <div>
    <div class="my-profile section-group">
      <div class="row">
        <div class="col-12">
          <div class="col-md-8 col-xs-12 content">
            <div class="col-form-label f-weight"> {{ $t('Social.group.groupBlackList.search_user') }}</div>
          </div>
          <div class="sear row">
            <div class="col-md-10">
              <el-input v-model="displayName" :placeholder="$t('Social.group.groupBlackList.Searchingusers')"></el-input>
            </div>
            <div class="col-md-2 col-3">
              <button type="button" class="btn btn-primary" :title="$t('Social.group.groupBlackList.Searchingusers')" @click="handleCurrent(1)">
                <i class="fas fa-search"></i>
              </button>
            </div>
          </div>
          <!-- /.搜尋位置 -->

          <div class="content" id="searchMember">
            <!-- <div class="col form-label f-weight pb-2" :title="搜尋結果">
              搜尋結果
            </div>
            <div class="col-12" v-for="(item, ix) in qryResult" :key="ix">
              <label for="searched_username" class="col-9 ptrl-05 box" style="">{{ item.displayName }}</label>
              <button type="button" class="btn btn-primary" :title="加入黑名單" @click="bolockFalseFriends(item)">
                <i class="fas fa-user-slash">拉黑</i>
              </button>
            </div> -->
            <div class="member-list"><b> {{ $t('Social.group.groupBlackList.searchresult') }}</b><a @click="IsShow()" style="cursor: pointer;color:#26ad5e">{{ isShow ? $t('Social.group.groupBlackList.packup') : $t('Social.group.groupBlackList.unfold') }}</a></div>
            <transition name="bounce">
                <div v-show="isShow" >
                <div class="member-list" v-for="(item, ix) in qryResult" :key="ix">
                <div>
                  <!-- <a href="#">{{ item.displayName }}</a> -->
                    <router-link :to="{ name: 'customerPublishLook', query: { 'authorId': item.userId } }">{{ item.displayName }}</router-link>
                </div>
                <div>
                  <button type="button" :title="$t('Social.group.groupBlackList.blacklist')" class="btn btn-primary" @click="bolockFalseFriends(item)"><i
                      class="fas fa-user-slash"> {{ $t('Social.group.groupBlackList.masking') }}</i></button>
                </div>
              </div>
              </div>
            </transition>
        
          </div>
          <div class="col-12 my-2">
            <transition name="bounce">
              <pagination v-if="qryResult.length > 0 && isShow " :currentPage="pageParams.currentPage" :total="pageParams.total"
                :limit="pageParams.limit" :small="true" :hide-on-single-page="true" :pageSizes="pageParams.pageSizes"
                @handleCurrentChange="handleCurrent" @handleSizeChange="handleSize" />
            </transition>
            </div>
          <!-- /.搜尋結果 -->


          <div class="content pt-4">
            <div class="label-title">
              <div class="form-label f-weight">
                 {{ $t('Social.group.groupBlackList.Blockingusers') }}({{ pageParams2.total }} {{ $t('Social.group.groupBlackList.a') }})
              </div>
              <div class="form-label f-weight">
                <div>
                   {{ $t('Social.group.groupBlackList.batchoperation') }}
                  <button type="button" class="btn_icon btn_icon-primary" @click="quBolockFalseFriends()"
                    :title="$t('Social.group.groupBlackList.Removedblacklist')"><i class="fas fa-minus"></i></button>
                  <input type="checkbox" class="input-general" v-model="checked" @click="checkedAll()" aria-label="...">
                </div>
              </div>
            </div>
            <div class="member-list" v-for="item in qryResult2" :key="item.id">
              <div>
                  <router-link :to="{ name: 'customerPublishLook', query: { 'authorId': item.sgL_ToUsersId } }">{{ item.sgL_ToUsersName }}</router-link>
              </div>
              <div>
                <button type="button" class="btn_icon btn_icon-primary" :title="$t('Social.group.groupBlackList.Removedblacklist')"
                  @click="quBolockFalseFriends(item)"><i class="fas fa-minus"></i></button>
                <input type="checkbox" class="input-table" :value="[item.id,item.sgL_ToUsersId]" v-model="checkList"
                  aria-label="...">
              </div>
            </div>
          </div>
          <!-- <div class="content pt-4">
            <div class="col form-label f-weight pb-3">
              拉黑({{ pageParams2.total }}個)
            </div>
            <div class="col-12">
              <div class="col-12" v-for="item in qryResult2" :key="item.id">
                <button type="button" class="btn_icon btn_icon-primary" :title="移出黑名單" @click="quBolockFalseFriends(item)">
                  <i class="fas fa-minus"></i>
                </button>
                <label class="col-5 ptrl-05">{{ item.sgL_ToUsersName }}</label>
              </div>
            </div>
          </div> -->
          <!-- /.黑名單列表 -->
          <!-- 頁碼 -->
          <div class="row my-5">
            <div class="col-12">
              <pagination v-if="qryResult2.length > 0" :currentPage="pageParams2.currentPage" :total="pageParams2.total"
                :limit="pageParams2.limit" :small="true" :hide-on-single-page="true" :pageSizes="pageParams2.pageSizes"
                @handleCurrentChange="handleCurrent2" @handleSizeChange="handleSize2" />
            </div>
          </div>
          <!-- /.頁碼 -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pagination from "@/components/common/Page";
export default {
  components: { pagination },
  data() {
    return {
      displayName: "",
      checked: false,
      isShow: false,
      checkList: [],
      qryResult: [],
      pageParams: {
        currentPage: 1,
        limit: 5,
        total: 0,
        pageSizes: [5, 10, 15, 20],
      },
      qryResult2: [],
      pageParams2: {
        currentPage: 1,
        limit: 5,
        total: 0,
        pageSizes: [5, 10, 15, 20],
      },
    };
  },
  watch: { //深度 watcher
    'checkList': {
      handler: function (val, oldVal) {
        if (val.length === this.qryResult2.length && val.length !== 0) {
          this.checked = true;
        } else {
          this.checked = false;
        }
      },
      deep: true
    }
  },
  created() {
    this.blockList();
  },
  methods: {
    checkedAll() {
      var _this = this;
      if (_this.checked) { //实现反选
        _this.checkList = [];
      } else { //实现全选
        _this.checkList = [];
        _this.qryResult2.forEach(function (item, index) {
          _this.checkList.push([item.id,item.sgL_ToUsersId]);
        });
      }
    },
    IsShow(){
      this.isShow = !this.isShow;
    },
    find() {
      this.$api.social
        .FriendsFindUsers({
          displayName: this.displayName,
          SkipCount: (this.pageParams.currentPage - 1) * this.pageParams.limit,
          MaxResultCount: this.pageParams.limit,
        })
        .then((res) => {
          this.qryResult = res.data.result.items;
          this.pageParams.total = res.data.result.totalCount;
        });
    },
    async quBolockFalseFriends(item) {

      let ids = item == null ? this.checkList : [[item.id,item.sgL_ToUsersId]];
      let params = {};
       ids.forEach((i)=>{
        return  params[i[0]] = i[1];
      })
      // console.log(params);
      const { data: res } = await this.$api.social.quBolockFalseFriendsBatch(params);
      // console.log(res);
      if (res.success) {
        this.$message.success(this.$t('message.operatesuccessfully'));
        this.checkList = [];
        this.blockList();
      } else {
        this.$message.error(res.error.message);
      }

      // this.$api.social
      //   .quBolockFalseFriends({
      //     id: item.id,
      //     usersId: item.sgL_ToUsersId,
      //   })
      //   .then((res) => {
      //     if (res.data.success) {
      //       this.$message({ type: "success", message: this.$t('message.operatesuccessfully') });
      //       this.blockList();
      //     } else {
      //       this.$message.error({
      //         type: "error",
      //         message: res.data.error.message,
      //       });
      //     }
      //   });
    },
    bolockFalseFriends(item) {
      this.$api.social
        .bolockFalseFriends({
          usersId: item.userId,
        })
        .then((res) => {
          if (res.data.success) {
            this.$message({ type: "success", message: this.$t('message.operatesuccessfully') });
            this.blockList();
          } else {
            this.$message.error({
              type: "error",
              message: res.data.error.message,
            });
          }
        });
    },
    blockList() {
      this.$api.social
        .blockList({
          SkipCount:
            (this.pageParams2.currentPage - 1) * this.pageParams2.limit,
          MaxResultCount: this.pageParams2.limit,
        })
        .then((res) => {
          this.qryResult2 = res.data.result.items;
          this.pageParams2.total = res.data.result.totalCount;
        });
    },
    handleCurrent(val) {
      this.pageParams.currentPage = val;
      this.find();
      this.isShow = true;
    },
    handleSize(val) {
      this.pageParams.limit = val;
      this.pageParams.currentPage = 1;
      this.find();
    },
    handleCurrent2(val) {
      this.pageParams2.currentPage = val;
      this.blockList();
    },
    handleSize2(val) {
      this.pageParams2.limit = val;
      this.pageParams2.currentPage = 1;
      this.blockList();
    },
  },
};
</script>

<style scoped>
/* New list style */
.label-title {
  background: #26ad5e;
  padding: 5px 10px;
  color: #fff;
  border-radius: 3px;
  display: flex !important;
  justify-content: space-between;
}

.label-title .btn_icon {
  color: #fff;
}

.member-list {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  align-items: center;
  border-bottom: #dee2e6 1px solid;
}

.member-list:last-child {
  border-bottom: none;
}

#searchMember,
#searchMember-two {
  border: #dee2e6 1px solid;
  border-radius: 5px;
  margin-top: 20px;
}


.group-set {
  width: 100%;
}

/* ./Friend list */

/* Post */
.post-modal {
  max-width: 1200px;
  margin: auto;
  padding: 50px;
}

.post-modal .row {
  align-items: stretch;
}

.post-modal .feedpost-action {
  margin: 12px 0;
  border-bottom: 1px solid #ececec;
}

/* Post - Photo */
#feedback_photo_aj {
  display: grid;
  align-items: center;
  background: #000;
}

/* ./Post - Photo */

/* Post Comment */
.feedpost-content2 {
  padding-top: 10px;
}

.feedpost-comment-list {
  max-height: 50vh;
  overflow: auto;
}

/* ./Post Comment */


.nav-link {
  border: 0px;
  background: no-repeat;
  padding: 8px 16px;
  line-height: 24px;
}

/* Bookmark Play Button */
button.vjs-big-play-button {
  position: absolute;
  right: 35%;
  top: 50%;
  margin-left: -1.5em;
  background-color: rgba(0, 0, 0, .45);
  margin-top: -1em !important;
  border-radius: 10px;
  width: 60px;
  height: 44px !important;
  border: 1px solid #fff;
  color: #fff;
}
/* .bounce-enter-active, .bounce-leave-active {
  transition: opacity .5s;
}
.bounce-enter, .bounce-leave-to  {
  opacity: 0;
} */
</style>


// WEBPACK FOOTER //
// src/components/Social/group/groupBlackList.vue